import { nothing } from '$helper/functions/utils'
import { SelectableUserListItem } from './selectable-user-list-item'
import { UserStatus } from '../user-status'

interface Props {
  userId: string
  selected: boolean
  hasDivider?: boolean
  onSelectedChange?: (selected: boolean) => unknown
  isPassive?: boolean
}

export function SelectableUserListItemWithStatus({
  userId,
  selected,
  hasDivider,
  onSelectedChange = nothing,
  isPassive,
}: Props) {
  return (
    <SelectableUserListItem
      userId={userId}
      secondaryText={<UserStatus userId={userId} />}
      selected={selected}
      hasDivider={hasDivider}
      onSelectedChange={onSelectedChange}
      isPassive={isPassive}
    />
  )
}
